<script>
export default {
  name: 'BrushIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.8098 3.94009C20.4998 7.21009 17.5098 11.4801 14.6598 14.2701C14.2498 11.6901 12.1898 9.67009 9.58984 9.31009C12.3898 6.45009 16.6898 3.42009 19.9698 2.10009C20.5498 1.88009 21.1298 2.05009 21.4898 2.41009C21.8698 2.79009 22.0498 3.36009 21.8098 3.94009Z"
      :fill="color"
    />
    <path
      d="M13.7791 15.09C13.5791 15.26 13.3791 15.43 13.1791 15.59L11.3891 17.02C11.3891 16.99 11.3791 16.95 11.3791 16.91C11.2391 15.84 10.7391 14.85 9.92914 14.04C9.10914 13.22 8.08914 12.72 6.96914 12.58C6.93914 12.58 6.89914 12.57 6.86914 12.57L8.31914 10.74C8.45914 10.56 8.60914 10.39 8.76914 10.21L9.44914 10.3C11.5991 10.6 13.3291 12.29 13.6691 14.43L13.7791 15.09Z"
      :fill="color"
    />
    <path
      d="M10.4298 17.6198C10.4298 18.7198 10.0098 19.7698 9.20976 20.5598C8.59976 21.1798 7.77977 21.5998 6.77977 21.7198L4.32976 21.9898C2.98976 22.1398 1.83976 20.9898 1.98976 19.6398L2.25976 17.1798C2.49976 14.9898 4.32976 13.5898 6.26976 13.5498C6.45976 13.5398 6.66976 13.5498 6.86976 13.5698C7.71976 13.6798 8.53976 14.0698 9.22976 14.7498C9.89976 15.4198 10.2798 16.2098 10.3898 17.0398C10.4098 17.2398 10.4298 17.4298 10.4298 17.6198Z"
      :fill="color"
    />
  </svg>
</template>
